<template>
    <div
        class="md-form layout4 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <div
            class="md-form-container"
            :class="{
                right: layout === 'right'
            }"
        >
            <div class="info-right">
                <div class="info-right-title1">
                    <site-title
                        v-if="title"
                        :title="title"
                        align="left"
                    />
                </div>

                <info-form-v2
                    :registerRole="registerRole"
                    :tag="tag"
                    :questionnaire="questionnaire"
                    :onSubmitOption="onSubmitOption"
                    :formList="formList"
                    :showTitle="true"
                    :lenderStyle="lenderStyle"
                    :defaultMsg="defaultMsg"
                    :submitText="submitOptionText"
                    :submitStyle="{
                        borderColor: submitBgColor,
                        color: submitBgColor,
                    }"
                    :registerLogin="registerLogin"
                    @done="handleShowToast"
                    :disclaimerColor="colorMap?.text || '#a0a3af'"
                    submitPos="afterbottom"
                />

                <div class="agent-info">
                    <site-title 
                        :title="`${ agent.firstName || '' } ${ agent.lastName || '' }`"
                        :size="20"
                        :mbSize="20"
                    />
                    <p v-if="agent.phone" class="info-item">
                        <a
                            :href="'tel:' + agent.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >
                            <span>{{ $ft.formatPhone(agent.phone) }}</span>
                        </a>
                    </p>
                    <p v-if="agent.email" class="info-item">
                        {{ agent.email }}
                    </p>
                    <p v-if="agent.companyAddress" class="info-item">
                        <span>{{ agent.companyAddress }}</span>
                    </p>
                    <p v-if="agent.personalWebsite" class="info-item">
                        <span>{{ agent.personalWebsite }}</span>
                    </p>
                </div>
            </div>
            <form-toast
                v-model:visible="formToastVisible"
                v-bind="formToastOption"
                @confirm="handleToastConfirm"
            />

            <img-box
                v-if="useBgSrc"
                :src="useBgSrc"
                class="layout4-right-image"
            />
            <div v-else class="default-wrap">
                <site-img
                    :src="defaultImgSrc"
                    dir="width"
                /> 
            </div>
        </div>
    </div>
</template>

<script>
import common from '../index';
import infoFormV2 from '../info-form-v2.vue';
import formToast from '@/components/form-toast';

export default {
    mixins: [common],
    data: function() {
        return {};
    },
    components: {
        infoFormV2,
        formToast
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.layout4 {
    .md-form-container {
        display: flex;
        &.right {
            flex-direction: row-reverse;
            .info-right {
                padding: 100px 40px 100px 50px;
                @include media-600 {
                    padding: 20px 15px 0px;
                }
            }
        }
        @include media-600 {
            display: block;
        }
    }
    .layout4-right-image {
        width: 50%;
        @include media-600 {
            width: auto;
            height: 416px;
        }
    }
    .default-wrap {
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(218, 218, 218, 0.2);
        img {
            width: 100px;
            height: 87.5px;
            object-fit: contain;
            opacity: 0.3;
        }
        @include media-600 {
            width: auto;
            height: 416px;
            img {
                width: 50px;
                height: 44px;
            }
        }
    }
    .info-right {
        flex-shrink: 0;
        flex-grow: 0;
        box-sizing: border-box;
        padding: 50px;
        width: 50%;
        .info-right-title1{
            margin-bottom: 20px;
            .site-title{
                font-weight: 700;
            }
        }
        .basic-info {
            display: flex;
            flex-wrap: wrap;
            margin: 0px -10px;
            .basic-info-input {
                width: calc(50% - 20px);
                flex-shrink: 0;
                flex-grow: 1;
                margin: 10px;
                &.question,
                &[class*='paragraphText'] {
                    width: calc(100% - 20px);
                    margin-bottom: 3px;

                    textarea {
                        box-shadow: none;
                        width: 100%;
                        height: 40px;
                        padding: 10px 0px;
                        background: transparent;
                        color: var(--g-text-color);
                        border: 0 solid;
                        border-bottom: solid 1px var(--color-border);
                        font-size: 14px;
                    }
                    @include media-600 {
                        width: 100%;
                    }
                }
                @include media-600 {
                    width: 100%;
                    margin: 10px 0px;
                }
            }
            .chime-datepicker {
                input {
                    padding-left: 35px;
                    border-radius: 0;
                }
                .date-picker-input-wrapper {
                    line-height: 40px;
                    i.iconfont {
                        top: 0;
                        left: 0;
                        vertical-align: middle;
                        padding-left: 0;
                    }
                    input {
                        vertical-align: middle;
                    }
                }
            }
            @include media-600 {
                margin: 0px;
            }
        }
        .basic-info-input input,
        .basic-info-input .submit {
            width: 100%;
            height: 40px;
            box-shadow: none;
            padding: 0px;
            background: transparent;
            color: var(--g-text-color);
        }
        .basic-info-input input {
            font-size: 16px;
            font-weight: 600;
            border: 0 solid;
            border-bottom: solid 1px var(--color-border);
        }
        .disclaimer-wrap.opt-in {
            margin-top: 20px;
            font-size: 14px;
            color: var(--g-tip-color);
            .disclaimer-item {
                margin-top: 0;
                color: var(--g-tip-color);
            }
            .disclaimer-content {
                color: var(--g-tip-color);
            }
            .privacy-text::before {
                opacity: 0.5;
            }
        }
        @include media-600 {
            width: 100%;
            padding: 0 15px 0px 15px;
        }
        .agent-info{
            padding-top: 80px;
            .site-title {
                font-family: var(--font-bold);
                font-weight: 700;
            }
            .info-item{
                font-size: 14px;
                color: var(--g-tip-color);
                margin-top: 15px;
                @include media-600{
                    margin-top: 10px;
                }
            }
            @include media-600{
                padding-top: 30px;
                padding-bottom: 17px;
            }
        }
    }
    .info-form2 .submit-content input{
        width: 100%;
        height: 50px;
        font-size: 16px;
    }
    .info-form2 .submit-content .submit {
        min-width: 155px;
        height: 50px;
        font-size: 20px;
        padding: 0 20px;
        background-color: transparent;
        border: 1px solid var(--g-btn-background);
        color: var(--g-btn-background);
        font-family: var(--mg-button-font);
        @include media-600{
            width: 100%;
            font-size: 16px;
        }

    }

    .info-form2 .submit-content .submit-box {
        margin-top: 25px;
        @include media-600{
            width: 100%;
            margin-top: 30px;
        }
    }
    .basic-info-input .title{
        color: var(--g-tip-color);
    }
}
</style>
